import * as React from "react";

export const ApprovalTick = (props: React.SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={21} height={20} viewBox="0 0 21 20" fill="none" {...props}>
    <path
      d="M7.58333 8.74992L10.8066 11.1674C10.8689 11.2141 10.9565 11.2054 11.0084 11.1474L18 3.33325"
      stroke="#107C10"
      strokeWidth={1.4}
      strokeLinecap="round"
    />
    <path
      d="M18.0861 8.5014C18.4285 10.2349 18.167 12.0334 17.345 13.5975C16.523 15.1617 15.1901 16.3972 13.5682 17.0984C11.9463 17.7996 10.1332 17.9243 8.43062 17.4516C6.72803 16.9789 5.23865 15.9374 4.21036 14.5004C3.18208 13.0635 2.6769 11.3177 2.77891 9.55362C2.88092 7.78958 3.58397 6.11367 4.77104 4.8048C5.95811 3.49594 7.55762 2.63307 9.30335 2.35979C11.0491 2.08652 12.8358 2.41932 14.366 3.30282"
      stroke="#107C10"
      strokeWidth={1.2}
      strokeLinecap="round"
    />
  </svg>
);
